import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DropDownMenu from 'material-ui/DropDownMenu';
import MenuItem from 'material-ui/MenuItem';
import * as lodash from 'lodash';

var LLDropDownList = /*#__PURE__*/function (_Component) {
  _inherits(LLDropDownList, _Component);

  var _super = _createSuper(LLDropDownList);

  function LLDropDownList() {
    var _this;

    _classCallCheck(this, LLDropDownList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "itemSelected", function (event, index, value) {
      var item = _.find(_this.props.items, {
        id: value
      });

      if (_this.props.onChange && item) {
        _this.props.onChange(item);
      }
    });

    return _this;
  }

  _createClass(LLDropDownList, [{
    key: "render",
    value: function render() {
      var items = this.props.items.map(function (i) {
        return /*#__PURE__*/React.createElement(MenuItem, {
          value: i.id,
          primaryText: i.title,
          key: i.id
        });
      });
      var labelItem = this.props.label ? /*#__PURE__*/React.createElement(MenuItem, {
        value: this.props.label,
        primaryText: this.props.label
      }) : null;
      var val = this.props.value ? this.props.value.id : this.props.items[0].id;

      if (!val && this.props.label) {
        val = this.props.label;
      }

      return /*#__PURE__*/React.createElement(DropDownMenu, {
        style: _objectSpread(_objectSpread({}, this.props.style), {}, {
          width: this.props.fullWidth ? '100%' : 'auto'
        }),
        value: val,
        onChange: this.itemSelected,
        hintText: this.props.hintText
      }, labelItem, items);
    }
  }]);

  return LLDropDownList;
}(Component);

_defineProperty(LLDropDownList, "propTypes", {
  style: PropTypes.object,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  items: PropTypes.array,
  theme: PropTypes.object.isRequired,
  fullWidth: PropTypes.bool
});

_defineProperty(LLDropDownList, "defaultProps", {
  style: {},
  value: {},
  onChange: null,
  items: [],
  fullWidth: false
});

export { LLDropDownList as default };